import React from 'react';

export default function DifficultySelector({ value = 'easy', onChange }) {
  const options = [
    { key: 'easy', label: '🟢 Facile', color: 'easy' },
    { key: 'medium', label: '🟠 Moyen', color: 'medium' },
    { key: 'hard', label: '🔴 Expert', color: 'hard' }
  ];

  return (
    <div className="ds-root" role="radiogroup" aria-label="Difficulté">
      {options.map(opt => (
        <button
          key={opt.key}
          type="button"
          role="radio"
          aria-checked={value === opt.key}
          className={`ds-chip ${opt.color} ${value === opt.key ? 'active' : ''}`}
          onClick={() => onChange && onChange(opt.key)}
          aria-label={`Sélectionner ${opt.label}`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
